import Swiper from "@components/Swiper";
import cx from "classnames";
import styles from "./Experiencing.module.scss";
import Item from "./Item";
import useSwiper from "@hooks/useSwiper";
import Icons from "@gstyles/styleguide/icons";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useMemo, useState } from "react";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import _ from "lodash";
export default function Experiencing() {
  const { i18n } = useTranslationContext();
  const [reachEnd, $reachEnd] = useState(false);
  const [reachBeginning, $reachBeginning] = useState(true);
  const { pageData } = usePageContext();
  const experiencingAmanaki = helper.formatExperiencingAmanaki(pageData);

  const data = _.get(experiencingAmanaki, "slides", []);
  useSwiper(".swiper-experiencing", {
    speed: 1000,
    spaceBetween: 32,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      900: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".swiper-arrow-next-experiencing",
      prevEl: ".swiper-arrow-prev-experiencing",
    },
    on: {
      reachEnd: () => {
        setTimeout(() => {
          $reachEnd(true);
        }, 500);
      },
      slideChange: (swiper) => {
        if (swiper) {
          $reachBeginning(false);
          $reachEnd(false);
        }
      },
      reachBeginning: () => {
        setTimeout(() => {
          $reachBeginning(true);
        }, 500);
      },
    },
  });
  const prevIconVisible = useMemo(
    () => (reachBeginning ? "invisible" : "visible"),
    [reachBeginning]
  );
  const nextIconVisible = useMemo(
    () => (reachEnd ? "invisible" : "visible"),
    [reachEnd]
  );
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.titleSection)}>
        {i18n.t("HomeHotel10.experiencing.title")}
      </div>
      <div className={cx(styles.swiperWrapper)}>
        <Icons
          name="chevron-right-outline"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-prev-experiencing",
            styles.prevArrowIconMb,
            prevIconVisible
          )}
          alt="previous icon"
        />
        <Icons
          name="arrow-long-narrow-right"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-prev-experiencing",
            styles.prevArrowIcon,
            prevIconVisible
          )}
          alt="previous icon"
        />
        <Swiper className={cx("swiper-experiencing", styles.swiper)}>
          {data.map((item, index) => {
            return (
              <Item
                className="swiper-slide"
                data={item}
                key={`slide_${""}_${index}`}
              />
            );
          })}
        </Swiper>
        <Icons
          name="arrow-long-narrow-right"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-next-experiencing",
            styles.nextArrowIcon,
            nextIconVisible
          )}
          alt="next icon"
        />
        <Icons
          name="chevron-right-outline"
          color="#F7EEDF"
          className={cx(
            "swiper-arrow-next-experiencing",
            styles.nextArrowIconMb,
            nextIconVisible
          )}
          alt="next icon"
        />
      </div>
    </div>
  );
}
